function hasAddCoursePermission() {
  const permissions = alo7Account.permissions;
  return permissions.addCourse;
}

function hasRemoveCoursePermission() {
  const permissions = alo7Account.permissions;
  return permissions.removeCourse;
}

function hasEditCoursePermission() {
  const permissions = alo7Account.permissions;
  return permissions.editCourse;
}

export {
  hasAddCoursePermission,
  hasRemoveCoursePermission,
  hasEditCoursePermission,
};
